import React from 'react';

import { useHistory } from "react-router";
import { getRatioChart } from "api/urls";

import RatioContainer from 'components/wrapper/RatioContainer';



const RatioChart = (props) => {
    const history = useHistory()

    return (
        <div  {...props}>
            <RatioContainer
                url={getRatioChart(history.location.search)}
                title={"Ratios"}
            />
        </div>
    )
};

export default (RatioChart);
